module.exports = __webpack_public_path__ + "static/media/arrivals.ebd11c0f.svg";